export default __webpack_public_path__ + "static/media/close_icon_b2bdashboard_alert.703aa323.svg";